import React from 'react';
import {Box} from '@mui/material';
import {TaxDetailsTab} from '@/pages/components/tax-computation/TaxDetailsTab';
import type {AuditPeriodSlice} from '@/utils/auditPeriodSplit';

interface TaxComPreviewPanelProps {
    companyId: number;
    annualId: number;
    active: boolean;
    periods?: AuditPeriodSlice[];
    initialYearOfAssessment?: string | null;
    onRequestCloseParent?: () => void;
}

/**
 * Embeds existing Tax Computation UI inside Preview Dialog (no nested Dialog shell).
 */
export function TaxComPreviewPanel({
    companyId,
    annualId,
    active,
    periods,
    initialYearOfAssessment,
    onRequestCloseParent,
}: TaxComPreviewPanelProps) {
    if (!active) return null;
    return (
        <Box sx={{height: '100%', minHeight: 480}}>
            <TaxDetailsTab
                companyId={companyId}
                annualId={annualId}
                open={active}
                onClose={() => onRequestCloseParent?.()}
                periods={periods}
                initialYearOfAssessment={initialYearOfAssessment}
                embedded
                hideStandaloneExport
            />
        </Box>
    );
}
